// @ts-ignore
import type {IOrderTrueRoundTripState} from "@/store/states/IOrderTrueRoundTripState.interface";

const orderTrueRoundTrip = {
    prefix: 'trueRound.',
    namespaced: true,
    state: <IOrderTrueRoundTripState>{
        isTransportationFormValid: true,
        ids: null,
        pickUp: {
            id: null,
            city: null,
            address: null,
            address_to_show: null
        },
        dropOff: {
            id: null,
            city: null,
            address: null,
            address_to_show: null
        },
        tripDepartureDate: null,
        tripArrivalDate: null,
        tripPassengers: 1,
        transportations: null,
        forwardTicket:  {
            transportationId: null,
            isSelected: false,
            data: null,
            tripDate: null,
            pickUp: null,
            dropOff: null,
            pickup_specified_address: "",
            dropoff_specified_address: "",
            pickup_note: "",
            dropoff_note: ""
        },
        backTicket: {
            transportationId: null,
            isSelected: false,
            data: null,
            tripDate: null,
            pickUp: null,
            dropOff: null,
            pickup_specified_address: "",
            dropoff_specified_address: "",
            pickup_note: "",
            dropoff_note: ""
        },

    },
    mutations: {
        SET_TRANSPORTATION_FORM_VALID(state, payload: boolean): void {
            state.isTransportationFormValid = payload;
        },

        SET_STATE_PROP_VALUE(state: IOrderTrueRoundTripState, payload: {prop: string, value: any}[]): void {
            for (const obj of payload) {
                if (! state.hasOwnProperty(obj.prop)) {
                    console.error('Trying to set state prop that doesn\'t exist');
                    return;
                }
            }

            for (const obj of payload) {
                const prop = obj.prop;
                let value = obj.value;

                // Ensure props to be converted to object accordingly
                switch (prop) {
                    case 'tripDepartureDate':
                    case 'tripArrivalDate':
                        if (typeof value !== 'object') {
                            // @ts-ignore
                            value = new Date(value);
                        }
                        break;

                    case 'forwardTicket':
                    case 'backTicket':
                        if (typeof value !== 'object') {
                            // @ts-ignore
                            value.tripDate = new Date(value.tripDate);
                        }
                        break;
                }

                state[prop] = value;

                if (prop === 'transportations') {
                    continue;
                }

                localStorage.removeItem(orderTrueRoundTrip.prefix + prop);

                if (value !== undefined) {
                    localStorage.setItem(orderTrueRoundTrip.prefix + prop, value ? JSON.stringify(value) : value);
                }
            }
        },

        INITIALIZE_TRUE_ROUND_TRIP_STATE(state: IOrderTrueRoundTripState): void {
            state['defaultState'] = {...state};

            for (const prop of Object.getOwnPropertyNames(state)) {

                let value = localStorage.getItem(orderTrueRoundTrip.prefix + prop);

                if (value) {
                    value = JSON.parse(value);
                    switch (prop) {
                        case 'tripDepartureDate':
                        case 'tripArrivalDate':
                            // @ts-ignore
                            value = new Date(value);
                            break;
                        case 'forwardTicket':
                        case 'backTicket':
                            // @ts-ignore
                            value.tripDate = new Date(value.tripDate);
                            break;
                    }
                    state[prop] = value;
                }
            }
        },
        CLEAR_STATE(state: IOrderTrueRoundTripState): void {
            for (const prop of Object.getOwnPropertyNames(state)) {
                localStorage.removeItem(orderTrueRoundTrip.prefix + prop);

                if (state.defaultState) {
                    state[prop] = state.defaultState[prop];
                }
            }
        }

    },

    actions: {
        updateState(context, data: {prop: string, value: any}[]): void {
            context.commit('SET_STATE_PROP_VALUE', data);
        },
    },
    getters: {

    }
}

export default orderTrueRoundTrip;